<template>
  <div>
    <el-form @submit.native.prevent="saveTests" :inline="true">
      <el-form-item label="选择网校">
        <el-select
          v-model="model.maID"
          multiple
          @change="changeMajor"
          placeholder="网校"
        >
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          v-model="model.chID"
          @change="getCourse"
          multiple
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类">
        <el-select
          v-model="model.coID"
          @change="getClass"
          multiple
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类">
        <el-select
          v-model="model.clID"
          @change="changeClass"
          multiple
          placeholder="三级分类"
        >
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="添加班级">
        <el-select v-model="model._id" placeholder="班级">
          <el-option
            v-for="item in getgrade"
            :key="item.index"
            :label="item.grName"
            :value="item._id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="添加大纲">
        <el-select v-model="model.lineID" multiple placeholder="添加考试大纲">
          <el-option
            v-for="item in outline"
            :key="item.index"
            :label="item.lineName"
            :value="item.lineID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="添加备考指导">
        <el-select v-model="model.advID" multiple placeholder="添加备考指导">
          <el-option
            v-for="item in advice"
            :key="item.index"
            :label="item.advName"
            :value="item.advID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="题库testsID(自动生成)">
        <el-input
          :disabled="true"
          v-model="testsID"
          @input="createTestsID"
        ></el-input>
      </el-form-item>

      <el-form-item label="题库名称">
        <el-input style="width: 550px" v-model="model.testsName"></el-input>
      </el-form-item>

      <el-card style="margin-top: 25px">
        <!-- 上传封面图 -->
        <h3>上传题库主图</h3>
        <el-upload
          class="avatar-uploader"
          :action="$http.defaults.baseURL + '/tests/img/cover'"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          list-type="picture"
          :on-success="coUpload"
        >
          <div>
            <img v-show="showCoImg" :src="model.testsCoverImg" />
          </div>
          <el-button size="small" type="primary">点击封面图</el-button>
        </el-upload>
        <el-form-item style="margin-top: 35px" label="封面图网址">
          <el-input
            style="width: 550px"
            v-model="model.testsCoverImg"
          ></el-input>
        </el-form-item>
      </el-card>

      <el-card style="margin-top: 25px">
        <!-- 上传课程详情图 -->
        <h3>上传题库详情图</h3>
        <el-upload
          class="avatar-uploader"
          :action="$http.defaults.baseURL + '/tests/img/desc'"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          list-type="picture"
          :on-success="leUpload"
        >
          <div>
            <img v-show="showLeImg" :src="model.testsDescImg" />
          </div>
          <el-button size="small" type="primary">点击上传详情图</el-button>
        </el-upload>
        <el-form-item style="margin-top: 35px" label="详情图网址">
          <el-input
            style="width: 550px"
            v-model="model.testsDescImg"
          ></el-input>
        </el-form-item>
      </el-card>

      <el-form-item style="margin-top: 25px">
        <el-button type="primary" native-type="submit">点击创建</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    id: {},
  },
  data() {
    return {
      showCoImg: true,
      showLeImg: true,
      dataNum: 1,
      major: [],
      channel: [],
      course: [],
      shclass: [],
      getgrade: [],
      advice: [],
      outline: [],
      pageSize: 20,
      testsID: 0,
      model: {
        testsName: "",
        testsCoverImg: "",
        testsDescImg: "",
      },
    };
  },
  methods: {
    async saveTests() {
      try {
        const params = {
          maID: this.model.maID,
          chID: this.model.chID,
          coID: this.model.coID,
          clID: this.model.clID,
          testsID: this.model.testsID,
          testsName: this.model.testsName,
          testsCoverImg: this.model.testsCoverImg,
          testsDescImg: this.model.testsDescImg,
          gradeID: this.model._id,
        };

        if (this.id) {
          await this.$http.put("/category/lesson?_id=" + `${this.id}`, params);
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.$router.push("/lesson/list");
        } else {
          await this.$http.post("/tests/create", params);
          this.$message({
            type: "success",
            message: "创建成功",
          });
          this.$router.push("/tests/list");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel() {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        //console.log(getchannel);
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCourse(chID) {
      //console.log(item);
      try {
        const getcourse = await this.$http.get(
          "/category/getcourse",
          {
            params: { chID },
          },

          this.getGrade(chID),
          this.getAdvice(chID),
          this.getOutline(chID)
        );
        this.course = getcourse.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(coID) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID },
        });
        this.shclass = getclass.data;
        this.getGrade(coID);
        this.getAdvice(coID);
        this.getOutline(coID);
      } catch (error) {
        console.log(error);
      }
    },
    async changeClass(clID) {
      this.getAdvice(clID), this.getOutline(clID);
    },
    changeMajor() {
      this.getGrade();
    },

    async getOutline() {
      try {
        let params = {
          chID: this.model.chID,
          coID: this.model.coID,
          size: this.pageSize,
        };
        const result = await this.$http.get("/outline/getline", {
          params,
        });

        this.outline = result.data[0].result;
      } catch (error) {
        console.log(error);
      }
    },
    async getAdvice() {
      try {
        let params = {
          chID: this.model.chID,
          maID: this.model.maID,
          coID: this.model.coID,
          size: this.pageSize,
        };
        const result = await this.$http.get("/advice/getadvice", {
          params,
        });

        this.advice = result.data[0].result;
      } catch (error) {
        console.log(error);
      }
      //console.log(this.getgrade);
    },
    async getGrade() {
      try {
        let params = {
          chID: this.model.chID,
          maID: this.model.maID,
          coID: this.model.coID,
          size: this.pageSize,
        };
        const getGrade = await this.$http.get("/category/getgrade", {
          params,
        });

        this.getgrade = getGrade.data[0].result;
      } catch (error) {
        console.log(error);
      }
      //console.log(this.getgrade);
    },
    leUpload(res) {
      try {
        //console.log(res.detailImg);
        this.model.testsDescImg = res;
        this.showLeImg = false;
      } catch (error) {
        console.log(error);
      }
    },
    coUpload(res) {
      //console.log(res.coverImg);
      try {
        this.model.testsCoverImg = res;
        this.showCoImg = false;
      } catch (error) {
        console.log(error);
      }
    },
    handlePreview(file) {
      //console.log(file);
    },

    /*   async getlesson() {
      try {
        const getlesson = await this.$http.get("/category/getlesson");
        this.lesson = getlesson.data;
      } catch (error) {
        console.log(error);
      }
    }, */

    handleRemove(uploadFile, uploadFiles) {
      //.log(uploadFile, uploadFiles);
    },

    //课程编辑
    /* async getEditLesson() {
      try {
        const getEditLesson = await this.$http.get("/category/editlesson", {
          params: { id: this.id },
        });
        //console.log(getEditLesson.data[0].maID);
        this.contents = getEditLesson.data[0].contents;
        this.tvideo = getEditLesson.data[0].tvideo;
        this.model.maID = getEditLesson.data[0].maID;
        this.model.chID = getEditLesson.data[0].chID;
        this.model.coID = getEditLesson.data[0].coID;
        this.model.clID = getEditLesson.data[0].clID;
        this.model.teID = getEditLesson.data[0].teID;
        this.model.leName = getEditLesson.data[0].leName;
        this.model.leImg = getEditLesson.data[0].leImg;
        this.model.coverImg = getEditLesson.data[0].coverImg;
        // console.log(getEditLesson.data[0].coverImg);
      } catch (error) {
        console.log(error);
      }
    }, */
    createTestsID() {
      this.testsID = Date.now();
    },
  },
  //生成testsID

  created() {
    this.getMajor();
    this.getChannel();
    this.createTestsID();
    //this.geteacher();
    //this.getlesson();
    //this.id && this.getEditLesson(this.id);
  },
};
</script>

<style scoped></style>
